import {PropsWithChildren} from "react";

export const CriticalErrorVisualization = (props: PropsWithChildren<{error: Error}>) => {

    return (
        <div>
            <h1>Oh no... we have a problem!</h1>
            <p>It seems that something is not right...</p>
            <p>{props.error.message}</p>
        </div>
    );
}